export class DirtyItem {
  constructor(public component: string, public dirty: boolean) {}
}
